/** 浮动客服窗桌面端宽度边界；短视口会按可用空间自动收紧。 */
export const AGENT_SERVICE_WINDOW_MIN_WIDTH = 480;
export const AGENT_SERVICE_WINDOW_MAX_WIDTH = 1280;

const HORIZONTAL_GUTTER = 16;
const TOP_GUTTER = 32;
const BOTTOM_GUTTER = 16;
/** 宽高分别受视口限制，宽窗可以显示联系人侧栏。 */
export function agentServiceWindowSizeBounds({ viewportWidth }) {
  const maximumWidth = Math.max(0, Math.min(AGENT_SERVICE_WINDOW_MAX_WIDTH, Number(viewportWidth || 0) - HORIZONTAL_GUTTER * 2));
  return { minimumWidth: Math.min(AGENT_SERVICE_WINDOW_MIN_WIDTH, maximumWidth), maximumWidth };
}

/** 把窗口限制在视口安全范围内，防止标题栏或输入区被拖出页面。 */
export function clampAgentServiceWindowPosition({
  x,
  y,
  width,
  height,
  viewportWidth,
  viewportHeight,
}) {
  const maxX = Math.max(
    HORIZONTAL_GUTTER,
    Number(viewportWidth || 0) - Number(width || 0) - HORIZONTAL_GUTTER
  );
  const maxY = Math.max(
    TOP_GUTTER,
    Number(viewportHeight || 0) - Number(height || 0) - BOTTOM_GUTTER
  );
  return {
    x: Math.min(maxX, Math.max(HORIZONTAL_GUTTER, Number(x || 0))),
    y: Math.min(maxY, Math.max(TOP_GUTTER, Number(y || 0))),
  };
}

/** 八个把手独立调节宽高，北/西保持对侧锚点。 */
export function resizeAgentServiceWindow({ rect, direction, dx, dy, viewportWidth, viewportHeight }) {
  const bounds = agentServiceWindowSizeBounds({ viewportWidth, viewportHeight });
  const maxHeight = Math.max(0, viewportHeight - TOP_GUTTER - BOTTOM_GUTTER);
  const minHeight = Math.min(360, maxHeight);
  const width = Math.min(bounds.maximumWidth, Math.max(bounds.minimumWidth,
    rect.width + (direction.includes('e') ? Number(dx || 0) : direction.includes('w') ? -Number(dx || 0) : 0)));
  const height = Math.min(maxHeight, Math.max(minHeight,
    rect.height + (direction.includes('s') ? Number(dy || 0) : direction.includes('n') ? -Number(dy || 0) : 0)));
  const position = clampAgentServiceWindowPosition({
    x: direction.includes('w') ? rect.left + rect.width - width : rect.left,
    y: direction.includes('n') ? rect.top + rect.height - height : rect.top,
    width, height, viewportWidth, viewportHeight,
  });
  return { ...position, width, height };
}

export const AGENT_SERVICE_DOCK_BALL_SIZE = 48;

/** 中线保持原侧，方向依据真实矩形中心而非窗口左边缘。 */
export function resolveAgentServiceDockSide(rect, viewportWidth, previousSide = 'right', offsetLeft = 0) {
  const center = Number(rect.left) + Number(rect.width) / 2;
  const middle = offsetLeft + Number(viewportWidth) / 2;
  return center < middle ? 'left' : center > middle ? 'right' : previousSide;
}

export function clampAgentServiceDockBall({ x, y, viewportWidth, viewportHeight, offsetLeft = 0, offsetTop = 0 }) {
  const size = AGENT_SERVICE_DOCK_BALL_SIZE;
  const minX = offsetLeft + Math.min(16, Math.max(0, (viewportWidth - size) / 2));
  const minY = offsetTop + Math.min(32, Math.max(0, viewportHeight - size));
  return {
    x: Math.min(Math.max(minX, offsetLeft + viewportWidth - size - 16), Math.max(minX, x)),
    y: Math.min(Math.max(minY, offsetTop + viewportHeight - size - 16), Math.max(minY, y)),
  };
}

export function snapAgentServiceBall(input) {
  const side = input.side || resolveAgentServiceDockSide({ left: input.x, width: AGENT_SERVICE_DOCK_BALL_SIZE }, input.viewportWidth, input.previousSide, input.offsetLeft);
  const clamped = clampAgentServiceDockBall({ ...input, x: side === 'left' ? -Infinity : Infinity });
  return { ...clamped, side };
}

export function dockAgentServiceBall({ rect, previousSide = 'right', ...viewport }) {
  const side = resolveAgentServiceDockSide(rect, viewport.viewportWidth, previousSide, viewport.offsetLeft);
  return snapAgentServiceBall({ ...viewport, side, x: rect.left, y: rect.top });
}

/** 未拖球恢复原位置，拖动后跟随新侧边与顶部；宽高分别限制在视口内。 */
export function restoreAgentServiceDockWindow({ rect, ball, moved, offsetLeft = 0, offsetTop = 0, ...viewport }) {
  const bounds = agentServiceWindowSizeBounds(viewport);
  const width = Math.min(rect.width, bounds.maximumWidth);
  const height = Math.min(rect.height, Math.max(0, viewport.viewportHeight - TOP_GUTTER - BOTTOM_GUTTER));
  const x = moved ? (ball.side === 'left' ? offsetLeft + 16 : offsetLeft + viewport.viewportWidth - width - 16) : rect.left;
  const y = moved ? ball.y : rect.top;
  const clamped = clampAgentServiceWindowPosition({ x: x - offsetLeft, y: y - offsetTop, width, height, ...viewport });
  return { x: clamped.x + offsetLeft, y: clamped.y + offsetTop, width, height };
}
